// enum values also used for translation keys
export enum PriceNavigatorTableColumn {
  ProductName = 'product_name',
  Store = 'store',
  RetailPrice = 'retail_price',
  PriceInsights = 'price_insights',
  ProductCosts = 'product_costs',
  ShippingCosts = 'shipping_costs',
  EstimatedProfit = 'estimated_profit',
  EstimatedTaxes = 'estimated_taxes',
  PlatformCosts = 'platform_costs',
  ProfitChange = 'profit_change',
  LastPublished = 'last_published',
  PastRetailPrice = 'past_retail_price',
  PublishedRetailPrice = 'published_retail_price',
  ReviewPastRetailPrice = 'review_past_retail_price',
  ReviewPublishedRetailPrice = 'review_published_retail_price',
  PricingStrategy = 'pricing_strategy',
  CompareAtPrice = 'compare_at_price',
}

export const PRICE_NAVIGATOR_TABLE_DEFAULT_VISIBLE_COLUMNS = [
  PriceNavigatorTableColumn.ProductName,
  PriceNavigatorTableColumn.RetailPrice,
  PriceNavigatorTableColumn.PriceInsights,
  PriceNavigatorTableColumn.ProductCosts,
  PriceNavigatorTableColumn.ShippingCosts,
  PriceNavigatorTableColumn.EstimatedProfit,
];

export const PRICE_NAVIGATOR_DATE_FORMAT = 'MMM dd, yyyy, HH:mm';
